// extracted by mini-css-extract-plugin
export default {"setting-card":"SettingOverview_setting-card__ETkgl","card-list":"SettingOverview_card-list__5DPB5"};